<template>
  <div class="data-grid-popover-page">
    <keep-alive>
      <TemplateDataGrid v-if="renderGrid"
                        ref="dataGrid"
                        :key="extraGridKey || extraKey"
                        :gridId="extraKey"
                        :extraValue="extraId || extraValue"
                        v-bind="extraAttrs"></TemplateDataGrid>
      <template v-else>
        <DefaultLoading v-if="visible && !popperVisible" message="页面打开中..."></DefaultLoading>
      </template>
    </keep-alive>
  </div>
</template>

<script>
import TemplateDataGrid from '../../templates/TemplateDataGrid'
import DefaultLoading from '../../elements/loader/DefaultLoading'
import globalEvent from '../../../constants/globalEvent'
export default {
  name: 'DataGridPopoverPage',
  inject: {
    $popper: {
      default: null
    }
  },
  components: {
    TemplateDataGrid,
    DefaultLoading
  },
  props: {
    extraKey: {
      type: String,
      required: true
    },
    extraId: {
      required: false
    },
    extraValue: {
      required: false
    },
    extraParams: {
      type: Object,
      required: false
    },
    extraGridKey: {
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      popperVisible: false
    }
  },
  computed: {
    extraAttrs () {
      return this.$extend({}, this.extraParams)
    },
    renderGrid () {
      if (this.$popper) {
        return this.popperVisible
      } else {
        return this.visible
      }
    }
  },
  methods: {
    reloadChildGridData () {
      let dataGrid = this.$refs['dataGrid']
      if (dataGrid) {
        dataGrid.loadGridData()
      }
    },
    reloadGridData () {
      this.$emit('reloadGridData')
    },
    hidePopover () {
      this.$emit('hidePopover')
    },
    hidePopoverAndRefresh () {
      this.$emit('hidePopoverAndRefresh')
    },
    handleOpened () {
      this.popperVisible = true
    },
    handleClosed () {
      this.popperVisible = false
    },
    installEvent () {
      this.$bus.$on(`${globalEvent.templateGridPopoverPage.RELOAD_GRID_DATA}:${this.extraKey}`, this.reloadGridData)
      this.$bus.$on(`${globalEvent.templateGridPopoverPage.HIDE_POPOVER}:${this.extraKey}`, this.hidePopover)
      this.$bus.$on(`${globalEvent.templateGridPopoverPage.HIDE_POPOVER_AND_REFRESH}:${this.extraKey}`, this.hidePopoverAndRefresh)
      if (this.$popper) {
        this.$popper.$on('opened', this.handleOpened)
        this.$popper.$on('closed', this.handleClosed)
      }
    },
    uninstallEvent () {
      this.$bus.$off(`${globalEvent.templateGridPopoverPage.RELOAD_GRID_DATA}:${this.extraKey}`, this.reloadGridData)
      this.$bus.$off(`${globalEvent.templateGridPopoverPage.HIDE_POPOVER}:${this.extraKey}`, this.hidePopover)
      this.$bus.$off(`${globalEvent.templateGridPopoverPage.HIDE_POPOVER_AND_REFRESH}:${this.extraKey}`, this.hidePopoverAndRefresh)
      if (this.$popper) {
        this.$popper.$off('opened', this.handleOpened)
        this.$popper.$off('closed', this.handleClosed)
      }
    }
  },
  mounted () {
    this.installEvent()
  },
  beforeDestroy () {
    this.uninstallEvent()
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.reloadChildGridData()
      }
    },
    extraKey: function (val) {
      this.uninstallEvent()
      if (val) {
        this.installEvent()
      }
    }
  }
}
</script>

<style lang="scss">
  .data-grid-popover-page {
    width: 900px;
    max-width: 100%;
    height: 100%;
    & > .template-data-grid {
      width: 100%;
    }
  }
  .dimension--large {
    .data-grid-popover {
      & > .data-grid-popover-page {
        width: 1200px!important;
      }
    }
  }
  .dimension--small {
    .data-grid-popover {
      & > .data-grid-popover-page {
        width: 600px!important;
      }
    }
  }
  .dimension--mini {
    .data-grid-popover {
      & > .data-grid-popover-page {
        width: 540px!important;
      }
    }
  }
  .el-dialog__wrapper {
    & > .el-dialog {
      & > .el-dialog__body {
        .data-grid-popover-page {
          width: 100%;
        }
      }
    }
  }
  .data-grid-cascade {
    .data-grid-popover-page {
      width: 100%;
    }
  }
  .el-popover {
    .data-grid-popover-page {
      width: 800px;
      height: 450px;
    }
  }
</style>
